import config from '../config.json'

// eslint-disable-next-line import/prefer-default-export
export const constructConfig = user => ({
  params: {
    access_token: user.accessToken,
  },
  baseURL: config.baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})
